
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { Bind, Debounce } from 'lodash-decorators'
import { EnumLogoutType } from '@xt/client'

import SettingsGroup from '../../../views/Settings/Group/index.vue'
import SettingsItem from '../../../views/Settings/Item/index.vue'
import SettingsButton from '../../../views/Settings/Button/index.vue'

import IdentityVerify from './views/IdentityVerify/index.vue'
import UnBindWx from './views/UnBindWx/index.vue'
import RevokeAccountModal from './views/RevokeAccountModal/index.vue'

import type { UserInfo } from '@xt/client/entities/user/types'
import type { ICheckUserInfoResp } from '@xt/client/entities/my-v2/types.d'

@Observer
@Component({
  components: {
    SettingsGroup,
    SettingsItem,
    SettingsButton,
    IdentityVerify,
    UnBindWx,
    RevokeAccountModal
  }
})
export default class MySettingsAccount extends Vue {
  @Prop({ required: true }) userInfo: UserInfo

  get PageStore() {
    return this.$store.$storeUser
  }

  get passwordDescription() {
    if (this.userInfo.phoneNum || this.userInfo.email) {
      return '********'
    }

    return `暂未设置密码，设置后可使用密码登录`
  }

  get phoneDescription() {
    if (this.userInfo.phoneNum) {
      return this.$desensitization.phone(this.userInfo.phoneNum)
    }

    return `绑定后，可使用手机号验证码登录`
  }

  get emailDescription() {
    if (this.userInfo.email) {
      return this.$desensitization.email(this.userInfo.email)
    }

    return `绑定后，可使用邮箱直接登录`
  }

  bodyStyle = {
    backgroundColor: '#FAF9F7',
    width: '520px',
    height: '520px'
  }

  currentClickType: 'password' | 'phone' | 'email' | 'unBindWx' | '' = ''

  checkUserInfo: ICheckUserInfoResp = {}

  isCorrect(type) {
    return type === this.currentClickType
  }

  handleOk() {
    this.$store.$storeUser.onChangeBindVisible(false)
  }

  handleCancel() {
    this.$store.$storeUser.onChangeBindVisible(false)
  }

  EditorSetting(type: 'password' | 'phone' | 'email') {
    if (type === 'password') {
      if (!this.PageStore.UserInfo.phoneNum && !this.PageStore.UserInfo.email) {
        this.$msg('您还未绑定手机号或邮箱')
        return
      }
    }

    this.changModalStyle('other')
    this.currentClickType = type
    this.$store.$storeUser.onChangeBindVisible(true)
  }

  EditorBind(type: 'bindPhone' | 'bindEmail') {
    if (type === 'bindPhone') {
      this.EditorSetting('phone')
    } else {
      this.EditorSetting('email')
    }
  }

  changModalStyle(other?: any) {
    if (other) {
      this.bodyStyle.height = '520px'
    } else {
      this.bodyStyle.height = '224px'
    }
  }

  @Debounce(600, { leading: true, trailing: false })
  @Bind()
  async handleOutLogin() {
    await this.PageStore.onLogout()
    await this.PageStore.onOutLogin()
    window.location.replace(this.$router.resolve('/').href)
  }

  async hanldeRevokeAccount() {
    this.checkUserInfo = await this.PageStore.getUserCancelAccountCheckInfo()

    this.PageStore.onToggleLogoutVisible(true)
    this.PageStore.onToggleLogoutModal((this.checkUserInfo.purchaseProductCount && EnumLogoutType.ACCOUNT) || EnumLogoutType.NOTICE)
  }

  handleHideRevokeAccountModal() {
    this.PageStore.onToggleLogoutVisible(false)
  }

  hanldeBindWx() {
    this.PageStore.showWeiXinBind({
      title: '绑定微信',
      content: '使用微信扫描小程序码完成绑定'
    })
  }

  handleVerifyWx() {
    this.PageStore.showWeiXinVerify({
      title: '验证微信',
      content: '扫码验证绑定微信与使用微信是否一致'
    })
  }

  hanldeUnBindWx() {
    if (this.PageStore.needBindDevice) {
      return this.$msg('您未绑定邮箱及手机号，不允许解绑微信')
    }
    this.currentClickType = 'unBindWx'
    this.$store.$storeUser.onChangeBindVisible(true)
    this.changModalStyle()
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
